var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAlignRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 17,
  y: 1,
  width: 3,
  height: 19
}), /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 7.92893219,
  y: 9.03810042,
  width: 8.07106781,
  height: 3,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.452314,10.5736343 L11.333065,8.45438534 C10.9413967,8.06271707 10.936895,7.43219908 11.3302558,7.03883825 L12.0388382,6.33025582 C12.4289551,5.94013902 13.0548361,5.93351573 13.4543853,6.33306499 L16.2800033,9.15868294 L16.9885857,9.86726537 C17.3787025,10.2573822 17.3853258,10.8832632 16.9857765,11.2828125 L13.4543853,14.8142037 C13.0627171,15.2058719 12.4321991,15.2103737 12.0388382,14.8170128 L11.3302558,14.1084304 C10.940139,13.7183136 10.9335157,13.0924326 11.333065,12.6928833 L13.452314,10.5736343 Z",
  fill: "currentColor"
}))));
export default SvgAlignRight;